import * as React from 'react';
import {
  List,
  Datagrid,
  Filter,
  Edit,
  Create,
  SimpleForm,
  TextInput,
  SelectInput,
  DateInput,
  TextField,
  DateField,
  ReferenceField,
  ReferenceInput,
} from 'react-admin';

const useTxtData = {
  table: {
    id: 'id',
    S_xumu_id: '畜牧',
    yimiaoName: '疫苗名称',
    status: '接种状态',
    remark: '备注',
    AtTime: '接种时间',
  }
};

export const S_xumu_jiezhongList = (props) => (
  <List {...props} filters={<Filters />}>
    <Datagrid>
      <TextField label={useTxtData.table.id} source="id" />
      <ReferenceField label={useTxtData.table.S_xumu_id} source="S_xumu_id" reference="Admin/CMSS_xumu">
        <TextField source="name" />
      </ReferenceField>
      <TextField label={useTxtData.table.yimiaoName} source="yimiaoName" />
      <TextField label={useTxtData.table.status} source="status" />
      <DateField label={useTxtData.table.AtTime} source="AtTime" showTime />
    </Datagrid>
  </List>
);

const Filters = (props) => (
  <Filter {...props}>
    <ReferenceInput label="畜牧" source="S_xumu_id" reference="Admin/CMSS_xumu" alwaysOn>
      <SelectInput optionText="name" />
    </ReferenceInput>
  </Filter>
);

export const S_xumu_jiezhongEdit = (props) => (
  <Edit {...props}>
    <SimpleForm>
      <ReferenceInput label="畜牧" source="S_xumu_id" reference="Admin/CMSS_xumu">
        <SelectInput optionText="name" />
      </ReferenceInput>
      <TextInput label={useTxtData.table.yimiaoName} source="yimiaoName" />
      <SelectInput label={useTxtData.table.status} source="status" choices={[
        { id: '已接种', name: '已接种' },
        { id: '未接种', name: '未接种' },
      ]} />
      <TextInput label={useTxtData.table.remark} source="remark" multiline />
      <DateInput label={useTxtData.table.AtTime} source="AtTime" />
    </SimpleForm>
  </Edit>
);

export const S_xumu_jiezhongCreate = (props) => (
  <Create {...props}>
    <SimpleForm>
      <ReferenceInput label="畜牧" source="S_xumu_id" reference="Admin/CMSS_xumu">
        <SelectInput optionText="name" />
      </ReferenceInput>
      <TextInput label={useTxtData.table.yimiaoName} source="yimiaoName" />
      <SelectInput label={useTxtData.table.status} source="status" choices={[
        { id: '已接种', name: '已接种' },
        { id: '未接种', name: '未接种' },
      ]} />
      <TextInput label={useTxtData.table.remark} source="remark" multiline />
      <DateInput label={useTxtData.table.AtTime} source="AtTime" />
    </SimpleForm>
  </Create>
);